import DialogNotAllowBooking from './DialogNotAllowBooking'

export default DialogNotAllowBooking 